import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private keyStore$: any = {};

  private store$: any;

  constructor() { }

  private getStoreData(key?: string, dataObj?: object) {
    if (key !== undefined && this.keyStore$ !== undefined) {
      return this.keyStore$[key] ? this.keyStore$[key] : undefined;
    } else if (dataObj !== undefined) {
      return dataObj;
    } else {
      return this.store$ !== undefined && key === undefined
        ? JSON.parse(JSON.stringify(this.store$))
        : undefined;
    }
  }

  private _set(
    data: any,
    keyObj: any,
    value?: any,
    type: string = 'set'
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const keyLength = keyObj.length;
      const newKey = keyObj;
      if (keyObj.length === 0) {
        reject();
      }
      for (let index = 0; index < keyObj.length; index++) {
        const key = keyObj[index];
        newKey.splice(index, 1);
        if (data !== undefined && data.hasOwnProperty(key)) {
          if (keyLength === index + 1) {
            if (data[key] !== undefined && type === 'insert') {
              if (data[key] instanceof Array) {
                data[key].push(value);
              } else {
                data[key] = Object.assign(data[key], value);
              }
            } else {
              data[key] = value;
            }
            resolve({ store: data, value: data[key] });
          } else {
            this._set(data[key], newKey, value, type).then((res) => {
              data[key] = res.store;
              resolve({ store: data, value: res.value });
            });
          }
        } else {
          if (keyLength === index + 1) {
            if (data[key] !== undefined && type === 'insert') {
              if (data[key] instanceof Array) {
                data[key].push(value);
              } else {
                data[key] = Object.assign(data[key], value);
              }
            } else {
              data[key] = value;
            }
            resolve({ store: data, value: data[key] });
          } else {
            this._set({}, newKey, value, type).then((res) => {
              data[key] = res.store;
              resolve({ store: data, value: res.value });
            });
          }
        }
      }
    });
  }

  async set(
    key: string,
    value: any,
    dataKey?: string,
    dataObj?: object
  ): Promise<any> {
    const keyObj = key.split('.');
    let data = this.getStoreData(dataKey, dataObj);
    if (data === undefined) {
      data = {};
      if (dataKey !== undefined && !this.keyStore$[dataKey]) {
        this.keyStore$[dataKey] = {};
      } else if (dataObj === undefined) {
        this.store$ = {};
      }
    }
    return await this._set(data, keyObj, value).then((res) => {
      if (dataKey !== undefined) {
        this.keyStore$[dataKey] = res.store;
        return res.value;
      } else if (dataObj === undefined) {
        this.store$ = res.store;
        return res.value;
      } else {
        return res.store;
      }
    });
  }

  async insert(
    key: string,
    value: any,
    dataKey?: string,
    dataObj?: object
  ): Promise<any> {
    const keyObj = key.split('.');
    let data = this.getStoreData(dataKey, dataObj);
    if (data === undefined) {
      data = {};
      if (dataKey !== undefined && !this.keyStore$[dataKey]) {
        this.keyStore$[dataKey] = {};
      } else if (dataObj === undefined) {
        this.store$ = {};
      }
    }
    return await this._set(data, keyObj, value, 'insert').then((res) => {
      if (dataKey !== undefined) {
        this.keyStore$[dataKey] = res.store;
        return res.value;
      } else if (dataObj === undefined) {
        this.store$ = res.store;
        return res.value;
      } else {
        return res.store;
      }
    });
  }

  async getAll(dataKey?: string): Promise<any> {
    return await new Promise((resolve, reject) => {
      resolve(this.getStoreData(dataKey));
    });
  }

  private _get(data: any, keyObj: any, value?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const keyLength = keyObj.length;
      const newKey = keyObj;
      if (keyObj.length === 0) {
        reject();
      }
      for (let index = 0; index < keyObj.length; index++) {
        const key = keyObj[index];
        newKey.splice(index, 1);
        if (data !== undefined && data.hasOwnProperty(key)) {
          if (keyLength === index + 1) {
            resolve(data[key]);
          } else {
            this._get(data[key], newKey, value).then((res) => {
              resolve(res);
            });
          }
        } else {
          resolve(value);
        }
      }
    });
  }

  async get(
    key: string,
    dataKey?: string,
    dataObj?: object,
    value?: any
  ): Promise<any> {
    const keyObj = key.split('.');
    const data = this.getStoreData(dataKey, dataObj);
    if (data !== undefined) {
      return await this._get(data, keyObj, value).then((res) => res);
    } else {
      return await new Promise((resolve, reject) => {
        resolve(value);
      });
    }
  }

  private _check(data: any, keyObj: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const keyLength = keyObj.length;
      const newKey = keyObj;
      if (keyObj.length === 0) {
        reject();
      }
      for (let index = 0; index < keyObj.length; index++) {
        const key = keyObj[index];
        newKey.splice(index, 1);
        if (data !== undefined && data.hasOwnProperty(key)) {
          if (keyLength === index + 1) {
            resolve(true);
          } else {
            this._check(data[key], newKey).then((res) => {
              resolve(res);
            });
          }
        } else {
          resolve(false);
        }
      }
    });
  }

  async check(key: string, dataKey?: string, dataObj?: object): Promise<any> {
    const keyObj = key.split('.');
    const data = this.getStoreData(dataKey, dataObj);
    if (data !== undefined) {
      return await this._check(data, keyObj);
    } else {
      return await new Promise((resolve, reject) => {
        resolve(false);
      });
    }
  }

  private _delete(data: any, keyObj: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const keyLength = keyObj.length;
      const newKey = keyObj;
      if (keyObj.length === 0) {
        reject();
      }
      for (let index = 0; index < keyObj.length; index++) {
        const key = keyObj[index];
        newKey.splice(index, 1);
        if (data !== undefined && data.hasOwnProperty(key)) {
          if (keyLength === index + 1) {
            const deleteValue = data[key];
            if (data instanceof Array) {
              data.splice(key, 1);
              if (data.length === 0) {
                data = undefined;
              }
            } else {
              delete data[key];
            }
            resolve({ store: data, value: deleteValue });
          } else {
            this._delete(data[key], newKey).then((res) => {
              data[key] = res.store;
              resolve({ store: data, value: res.value });
            });
          }
        } else {
          resolve({ store: data, value: null });
        }
      }
    });
  }

  async delete(key: string, dataKey?: string, dataObj?: object): Promise<any> {
    const keyObj = key.split('.');
    const data = this.getStoreData(dataKey, dataObj);
    if (data !== undefined) {
      return await this._delete(data, keyObj).then((res) => {
        if (dataKey !== undefined) {
          this.keyStore$[dataKey] = res.store;
          return res.value;
        } else if (dataObj === undefined) {
          this.store$ = res.store;
          return res.value;
        } else {
          return res.store;
        }
      });
    } else {
      return await new Promise((resolve, reject) => {
        resolve(false);
      });
    }
  }

  clear(dataKey?: string) {
    if (dataKey !== undefined && this.keyStore$[dataKey] !== undefined) {
      this.keyStore$[dataKey] = undefined;
    } else {
      this.store$ = undefined;
    }
    return true;
  }
}
